import { Link } from "react-router-dom";
import { Heart, Mail, Shield } from "lucide-react";
import { useLang } from "../i18n/LangContext";

export function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 border-t border-[#222636] bg-[#0f1117]" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2.5" data-testid="footer-logo">
              <div className="flex h-9 w-9 items-center justify-center rounded-2xl dc-gradient-bg">
                <Heart className="h-4 w-4 text-white" fill="white" strokeWidth={2.5} />
              </div>
              <span className="font-display text-base font-bold tracking-tight text-white">AI Dating Coach</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-[#a8adbd]">{t("tagline")}</p>
            <div className="mt-4 flex items-center gap-2 text-xs text-[#a8adbd]">
              <Shield className="h-3.5 w-3.5 text-[#32d583]" />
              {lang === "pl" ? "Prywatne · Bez logowania do Aplikacji · Tylko Twoje dane" : "Private · No Needed login · Your data only"}
            </div>
          </div>

          <div>
            <h3 className="mb-3 font-display text-sm font-semibold uppercase tracking-wider text-white">
              {lang === "pl" ? "Informacje prawne" : "Legal"}
            </h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/legal/privacy" data-testid="footer-privacy" className="text-[#a8adbd] hover:text-white">
                  {lang === "pl" ? "Polityka prywatności" : "Privacy policy"}
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" data-testid="footer-terms" className="text-[#a8adbd] hover:text-white">
                  {lang === "pl" ? "Regulamin" : "Terms of service"}
                </Link>
              </li>
              <li>
                <Link to="/legal/cookies" data-testid="footer-cookies" className="text-[#a8adbd] hover:text-white">
                  {lang === "pl" ? "Polityka cookies" : "Cookie policy"}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-3 font-display text-sm font-semibold uppercase tracking-wider text-white">
              {lang === "pl" ? "Kontakt" : "Contact"}
            </h3>
            <ul className="space-y-2 text-sm text-[#a8adbd]">
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-3.5 w-3.5 flex-shrink-0 text-[#ff4458]" />
                <a href="mailto:kontakt@mateuszzalewski.pl" data-testid="footer-email" className="hover:text-white">
                  kontakt@mateuszzalewski.pl
                </a>
              </li>
              <li className="text-xs leading-relaxed">Mateusz Łukasz Zalewski<br />Wołomin ul. Szkolna 2<br />Działalność Nierejestrowana</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-[#222636] pt-6 text-xs text-[#a8adbd] sm:flex-row sm:items-center">
          <div>© {year} Mateusz.Ł.Zalewski . {lang === "pl" ? "Wszystkie prawa zastrzeżone." : "All rights reserved."}</div>
          <div className="flex items-center gap-1.5">
            {lang === "pl" ? "Stworzone z" : "Built with"}
            <Heart className="h-3 w-3 text-[#ff4458]" fill="#ff4458" />
            {lang === "pl" ? "i AI" : "and AI"}
          </div>
        </div>
      </div>
    </footer>
  );
}
